import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Image,
  ListGroup,
  Button,
  Card,
  Tabs,
  Tab,
  Modal,
  Accordion,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { listProductDetails } from "../actions/productActions";
import {
  FaListUl,
  FaVideo,
  FaStar,
  FaImages,
  FaTractor,
  FaPlusCircle,
} from "react-icons/fa";
import { addToCart } from "../actions/cartActions";

function ProductScreen({ match, history }) {
  const dispatch = useDispatch();
  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [qty] = useState(1);
  const [addedTractor, setAddedTractor] = useState(null);
  const [addedAttachments, setAddedAttachments] = useState([]);
  const [addedOptions, setAddedOptions] = useState([]);
  const [validImages, setValidImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    dispatch(listProductDetails(match.params.id));
  }, [dispatch, match.params.id]);

  useEffect(() => {
    const checkImage = async (imageName) => {
      try {
        const res = await fetch(`/images/gallery/${product.name}/${imageName}`);
        return res.status === 200 ? imageName : null;
      } catch (err) {
        console.error(err);
        return null;
      }
    };

    const validateImages = async () => {
      const imageNames = Array.from(
        { length: 10 },
        (_, i) => `image${i + 1}.jpg`
      );
      const validImages = await Promise.all(
        imageNames.map((imageName) => checkImage(imageName))
      );
      setValidImages(validImages.filter((name) => name !== null));
    };

    if (product && product.name && !validImages.length) {
      validateImages();
    }
  }, 
  [product, validImages.length]);
  // [product?.name]);

  // Tractors inventory
  const addToQuoteHandlerTractor = (tractorId) => {
    if (addedTractor === tractorId) {
      setAddedTractor(null);
    } else {
      setAddedTractor(tractorId);
    }
  };
  const removeFromQuoteHandlerTractor = () => {
    setAddedTractor(null);
  };

  // attachments
// attachments
const addToQuoteHandler = (attachmentId) => {
  const attachment = product.attachments.find(a => a._id === attachmentId);
  if (attachment.type === 'loaders' || attachment.type === 'backhoes') {
    // Remove any existing attachments of the same type
    setAddedAttachments(addedAttachments.filter(id => 
      product.attachments.find(a => a._id === id).type !== attachment.type
    ));

    // Add the selected attachment if it's not already selected
    if (!addedAttachments.includes(attachmentId)) {
      setAddedAttachments([...addedAttachments.filter(id => 
        product.attachments.find(a => a._id === id).type !== attachment.type
      ), attachmentId]);
    }
  } else {
    // For other types, use the existing logic
    if (addedAttachments.includes(attachmentId)) {
      setAddedAttachments(addedAttachments.filter(id => id !== attachmentId));
    } else {
      setAddedAttachments([...addedAttachments, attachmentId]);
    }
  }
};

  // Options
  const addToQuoteHandlerOptions = (optionId) => {
    if (addedOptions.includes(optionId)) {
      setAddedOptions(addedOptions.filter((id) => id !== optionId));
    } else {
      setAddedOptions([...addedOptions, optionId]);
    }
  };

  // Calculate attachment total
  const attachmentTotal = addedAttachments.reduce((acc, attachmentId) => {
    const attachment = product.attachments.find((a) => a._id === attachmentId);
    return acc + (attachment ? parseFloat(attachment.price) : 0);
  }, 0);
  // Calculate option total
  const optionTotal = addedOptions.reduce((acc, optionId) => {
    const option = product.options.find((o) => o._id === optionId);
    return acc + (option ? parseFloat(option.price) : 0);
  }, 0);
  // Calculate sum total
  const sumTotal = (
    parseFloat(
      product?.tractors?.find((t) => t._id === addedTractor)?.price ?? 0
    ) +
    attachmentTotal +
    optionTotal
  ).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const salesProgramGroup =
    product.salesProgramGroup?.length > 0
      ? {
          id: product.salesProgramGroup[0]._id,
          group: product.salesProgramGroup[0].group,
          // program 1
          op1_description: product.salesProgramGroup[0].op1_description,
          op1_tractor: product.salesProgramGroup[0].op1_tractor,
          op1_loader: product.salesProgramGroup[0].op1_loader,
          op1_backhoe: product.salesProgramGroup[0].op1_backhoe,
          op1_bank: product.salesProgramGroup[0].op1_bank,
          op1_rate: product.salesProgramGroup[0].op1_rate,
          op1_terms: product.salesProgramGroup[0].op1_terms,
          op1_other: product.salesProgramGroup[0].op1_other,
          // program 2
          op2_description: product.salesProgramGroup[0].op2_description,
          op2_bank: product.salesProgramGroup[0].op2_bank,
          op2_rate_1: product.salesProgramGroup[0].op2_rate_1,
          op2_terms_1: product.salesProgramGroup[0].op2_terms_1,
          op2_rate_2: product.salesProgramGroup[0].op2_rate_2,
          op2_terms_2: product.salesProgramGroup[0].op2_terms_2,
          op2_rate_3: product.salesProgramGroup[0].op2_rate_3,
          op2_terms_3: product.salesProgramGroup[0].op2_terms_3,
          op2_rate_4: product.salesProgramGroup[0].op2_rate_4,
          op2_terms_4: product.salesProgramGroup[0].op2_terms_4,
          op2_rebate: product.salesProgramGroup[0].op2_rebate,
          op2_other: product.salesProgramGroup[0].op2_other,
          // program 3
          op3_description: product.salesProgramGroup[0].op3_description,
          op3_bank: product.salesProgramGroup[0].op3_bank,
          op3_rate_1: product.salesProgramGroup[0].op3_rate_1,
          op3_terms_1: product.salesProgramGroup[0].op3_terms_1,
          op3_rate_2: product.salesProgramGroup[0].op3_rate_2,
          op3_terms_2: product.salesProgramGroup[0].op3_terms_2,
          op3_rate_3: product.salesProgramGroup[0].op3_rate_3,
          op3_terms_3: product.salesProgramGroup[0].op3_terms_3,
          op3_rate_4: product.salesProgramGroup[0].op3_rate_4,
          op3_terms_4: product.salesProgramGroup[0].op3_terms_4,
          op3_rebate: product.salesProgramGroup[0].op3_rebate,
          op3_other: product.salesProgramGroup[0].op3_other,
          // program 4
          op4_description: product.salesProgramGroup[0].op4_description,
          op4_bank: product.salesProgramGroup[0].op4_bank,
          op4_rate_1: product.salesProgramGroup[0].op4_rate_1,
          op4_terms_1: product.salesProgramGroup[0].op4_terms_1,
          op4_rate_2: product.salesProgramGroup[0].op4_rate_2,
          op4_terms_2: product.salesProgramGroup[0].op4_terms_2,
          op4_rate_3: product.salesProgramGroup[0].op4_rate_3,
          op4_terms_3: product.salesProgramGroup[0].op4_terms_3,
          op4_rate_4: product.salesProgramGroup[0].op4_rate_4,
          op4_terms_4: product.salesProgramGroup[0].op4_terms_4,
          op4_rebate: product.salesProgramGroup[0].op4_rebate,
          op4_other: product.salesProgramGroup[0].op4_other,
          // program 5
          op5_description: product.salesProgramGroup[0].op5_description,
          op5_free_loader: product.salesProgramGroup[0].op5_free_loader,
          op5_other: product.salesProgramGroup[0].op5_other,
          // program 6 - since May 2024
          op6_description: product.salesProgramGroup[0].op6_description,
          op6_bank: product.salesProgramGroup[0].op6_bank,
          op6_rate_1: product.salesProgramGroup[0].op6_rate_1,
          op6_terms_1: product.salesProgramGroup[0].op6_terms_1,
          op6_rate_2: product.salesProgramGroup[0].op6_rate_2,
          op6_terms_2: product.salesProgramGroup[0].op6_terms_2,
          op6_rate_3: product.salesProgramGroup[0].op6_rate_3,
          op6_terms_3: product.salesProgramGroup[0].op6_terms_3,
          op6_rate_4: product.salesProgramGroup[0].op6_rate_4,
          op6_terms_4: product.salesProgramGroup[0].op6_terms_4,
          op6_rebate: product.salesProgramGroup[0].op6_rebate,
          op6_other: product.salesProgramGroup[0].op6_other,
          // program 7 - since May 2024
          op7_description: product.salesProgramGroup[0].op7_description,
          op7_bank: product.salesProgramGroup[0].op7_bank,
          op7_rate_1: product.salesProgramGroup[0].op7_rate_1,
          op7_terms_1: product.salesProgramGroup[0].op7_terms_1,
          op7_rate_2: product.salesProgramGroup[0].op7_rate_2,
          op7_terms_2: product.salesProgramGroup[0].op7_terms_2,
          op7_rate_3: product.salesProgramGroup[0].op7_rate_3,
          op7_terms_3: product.salesProgramGroup[0].op7_terms_3,
          op7_rate_4: product.salesProgramGroup[0].op7_rate_4,
          op7_terms_4: product.salesProgramGroup[0].op7_terms_4,
          op7_rebate: product.salesProgramGroup[0].op7_rebate,
          op7_other: product.salesProgramGroup[0].op7_other,
          // program 8
          // op8_description: product.salesProgramGroup[0].op8_description,
          // op8_bank: product.salesProgramGroup[0].op8_bank,
          // op8_rate_1: product.salesProgramGroup[0].op8_rate_1,
          // op8_terms_1: product.salesProgramGroup[0].op8_terms_1,
          // op8_rate_2: product.salesProgramGroup[0].op8_rate_2,
          // op8_terms_2: product.salesProgramGroup[0].op8_terms_2,
          // op8_rate_3: product.salesProgramGroup[0].op8_rate_3,
          // op8_terms_3: product.salesProgramGroup[0].op8_terms_3,
          // op8_rate_4: product.salesProgramGroup[0].op8_rate_4,
          // op8_terms_4: product.salesProgramGroup[0].op8_terms_4,
          // op8_rebate: product.salesProgramGroup[0].op8_rebate,
          // op8_other: product.salesProgramGroup[0].op8_other,
          // program 9
          // op9_description: product.salesProgramGroup[0].op9_description,
          // op9_bank: product.salesProgramGroup[0].op9_bank,
          // op9_rate_1: product.salesProgramGroup[0].op9_rate_1,
          // op9_terms_1: product.salesProgramGroup[0].op9_terms_1,
          // op9_rate_2: product.salesProgramGroup[0].op9_rate_2,
          // op9_terms_2: product.salesProgramGroup[0].op9_terms_2,
          // op9_rate_3: product.salesProgramGroup[0].op9_rate_3,
          // op9_terms_3: product.salesProgramGroup[0].op9_terms_3,
          // op9_rate_4: product.salesProgramGroup[0].op9_rate_4,
          // op9_terms_4: product.salesProgramGroup[0].op9_terms_4,
          // op9_rebate: product.salesProgramGroup[0].op9_rebate,
          // op9_other: product.salesProgramGroup[0].op9_other,
          // std rates
          std_1_bank: product.salesProgramGroup[0].std_1_bank,
          std_1_rate_1: product.salesProgramGroup[0].std_1_rate_1,
          std_1_terms_1: product.salesProgramGroup[0].std_1_terms_1,
          std_1_rate_2: product.salesProgramGroup[0].std_1_rate_2,
          std_1_terms_2: product.salesProgramGroup[0].std_1_terms_2,
          std_1_rate_3: product.salesProgramGroup[0].std_1_rate_3,
          std_1_terms_3: product.salesProgramGroup[0].std_1_terms_3,
          std_1_rate_4: product.salesProgramGroup[0].std_1_rate_4,
          std_1_terms_4: product.salesProgramGroup[0].std_1_terms_4,

          std_2_bank: product.salesProgramGroup[0].std_2_bank,
          std_2_rate_1: product.salesProgramGroup[0].std_2_rate_1,
          std_2_terms_1: product.salesProgramGroup[0].std_2_terms_1,
          std_2_rate_2: product.salesProgramGroup[0].std_2_rate_2,
          std_2_terms_2: product.salesProgramGroup[0].std_2_terms_2,
          std_2_rate_3: product.salesProgramGroup[0].std_2_rate_3,
          std_2_terms_3: product.salesProgramGroup[0].std_2_terms_3,
          std_2_rate_4: product.salesProgramGroup[0].std_2_rate_4,
          std_2_terms_4: product.salesProgramGroup[0].std_2_terms_4,

          std_3_bank: product.salesProgramGroup[0].std_3_bank,
          std_3_rate_1: product.salesProgramGroup[0].std_3_rate_1,
          std_3_terms_1: product.salesProgramGroup[0].std_3_terms_1,
          std_3_rate_2: product.salesProgramGroup[0].std_3_rate_2,
          std_3_terms_2: product.salesProgramGroup[0].std_3_terms_2,
          std_3_rate_3: product.salesProgramGroup[0].std_3_rate_3,
          std_3_terms_3: product.salesProgramGroup[0].std_3_terms_3,
          std_3_rate_4: product.salesProgramGroup[0].std_3_rate_4,
          std_3_terms_4: product.salesProgramGroup[0].std_3_terms_4,

          std_4_bank: product.salesProgramGroup[0].std_4_bank,
          std_4_rate_1: product.salesProgramGroup[0].std_4_rate_1,
          std_4_terms_1: product.salesProgramGroup[0].std_4_terms_1,
          std_4_rate_2: product.salesProgramGroup[0].std_4_rate_2,
          std_4_terms_2: product.salesProgramGroup[0].std_4_terms_2,
          std_4_rate_3: product.salesProgramGroup[0].std_4_rate_3,
          std_4_terms_3: product.salesProgramGroup[0].std_4_terms_3,
          std_4_rate_4: product.salesProgramGroup[0].std_4_rate_4,
          std_4_terms_4: product.salesProgramGroup[0].std_4_terms_4,

          // std_5_bank: product.salesProgramGroup[0].std_5_bank,
          // std_5_rate_1: product.salesProgramGroup[0].std_5_rate_1,
          // std_5_terms_1: product.salesProgramGroup[0].std_5_terms_1,
          // std_5_rate_2: product.salesProgramGroup[0].std_5_rate_2,
          // std_5_terms_2: product.salesProgramGroup[0].std_5_terms_2,
          // std_5_rate_3: product.salesProgramGroup[0].std_5_rate_3,
          // std_5_terms_3: product.salesProgramGroup[0].std_5_terms_3,
          // std_5_rate_4: product.salesProgramGroup[0].std_5_rate_4,
          // std_5_terms_4: product.salesProgramGroup[0].std_5_terms_4,

          salesman_commission: product.salesProgramGroup[0].salesman_commission,
        }
      : null;

  const addToCartHandler = () => {
    let tractors = {};
    if (addedTractor) {
      const tractor = product.tractors.find((t) => t._id === addedTractor);
      tractors = {
        id: tractor._id,
        list_description: tractor.list_description,
        tire_description: tractor.tire_description,
        item_number: tractor.item_number,
        price: tractor.price,
        MSRP: tractor.MSRP,
      };
    }
    const attachments = addedAttachments.map((attachmentId) => {
      const attachment = product.attachments.find(
        (a) => a._id === attachmentId
      );
      return {
        id: attachment._id,
        name: attachment.name,
        type: attachment.type,
        price: attachment.price,
        MSRP: attachment.MSRP,
      };
    });
    const options = addedOptions.map((optionId) => {
      const option = product?.options?.find((o) => o._id === optionId);
      return {
        id: option._id,
        name: option.name,
        type: option.type,
        price: option.price,
        MSRP: option.MSRP,
      };
    });

    dispatch(
      addToCart(
        match.params.id,
        qty,
        tractors ? [tractors] : [],
        attachments,
        options,
        salesProgramGroup
      )
    );
    history.push(`/cart`);
  };

  const addToCartHandlerPublic = () => {
    const attachments = addedAttachments.map((attachmentId) => {
      const attachment = product.attachments.find(
        (a) => a._id === attachmentId
      );
      return {
        id: attachment._id,
        name: attachment.name,
        type: attachment.type,
        price: attachment.price, // Ensure price is included if needed
        MSRP: attachment.MSRP, // Include MSRP if it's required
      };
    });
    const options = addedOptions.map((optionId) => {
      const option = product.options.find((o) => o._id === optionId);
      return {
        id: option._id,
        name: option.name,
        type: option.type,
        price: option.price, // Ensure price is included if needed
        MSRP: option.MSRP, // Include MSRP if it's required
      };
    });
    dispatch(addToCart(match.params.id, qty, [], attachments, options)); // Assuming the third parameter is for tractors which is not used here
    history.push(`/cart`);
  };

  // Function to handle image click
  const handleImageClick = (imageName) => {
    setSelectedImage(`/images/gallery/${product.name}/${imageName}`);
    setShowModal(true);
  };
  // Close modal function
  const handleCloseModal = () => setShowModal(false);

  return (
    <div>
      <Link className="buttonBack" to="/">
        Go Back
      </Link>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <Row>
          <Col md={6}>
            <Image src={product?.image} alt={product?.name} fluid />
            {/* Accordion for additional sections */}
            <Accordion defaultActiveKey="0">
              {/* Specifications */}
              <Card
                className="rounded"
                style={{
                  margin: "0px 0px 5px 0px",
                }}
              >
                <Accordion.Toggle as={Card.Header} eventKey="0">
                  <FaListUl className="iconStyle" /> Specifications
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <span
                      className="productDescription"
                      dangerouslySetInnerHTML={{ __html: product.description }}
                    />
                    {/* More Details Button */}
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <a
                        href={product.url}
                        className="buttonBack"
                        target="_blank"
                      >
                        More Details
                      </a>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              {/* Videos */}
              <Card className="rounded">
                <Accordion.Toggle as={Card.Header} eventKey="1">
                  <FaVideo className="iconStyle" /> Videos
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    {/* Embed video using iframe */}
                    {product.url_video && (
                      <iframe
                        width="100%"
                        height="315"
                        src={product.url_video}
                        title="Product Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    )}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              {/* Features */}
              {/* TEMPORARILY DISABLE */}
              {/* <Card
                className="rounded"
                style={{
                  margin: "5px 0px 5px 0px",
                }}
              >
                <Accordion.Toggle as={Card.Header} eventKey="2">
                  <FaStar className="iconStyle" /> Features
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <span
                      className="productDescription"
                      dangerouslySetInnerHTML={{ __html: product.features }}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card> */}
              {/* Photo Gallery */}
              {/* TEMPORARILY DISABLE */}
              {/* <Card className="rounded">
                <Accordion.Toggle as={Card.Header} eventKey="3">
                  <FaImages className="iconStyle" /> Photo Gallery
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="3">
                  <Card.Body> */}
                    {/* Gallery Images */}
                    {/* {validImages.map((imageName) => (
                      <Image
                        key={imageName}
                        src={`/images/gallery/${product.name}/${imageName}`}
                        alt={imageName}
                        onClick={() => handleImageClick(imageName)}
                        className="imageThumbnail"
                        thumbnail
                      />
                    ))} */}
                  {/* </Card.Body>
                </Accordion.Collapse>
              </Card> */}
            </Accordion>
          </Col>
          {/* Modal for Image View */}
          <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>Image View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Image src={selectedImage} alt="Selected" fluid />
            </Modal.Body>
          </Modal>
          {/* PRODUCT NAME AND HP */}
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h1 className="productTitle">
                  {product.name}{" "}
                  <>
                    {" - "}
                    <span className="horsepower">{product.horsepower} HP</span>
                  </>
                </h1>
              </ListGroup.Item>
              <ListGroup.Item>
                <Tabs defaultActiveKey="tractors" id="product-tabs">
                  {/* TRACTORS */}
                  <Tab eventKey="tractors" title="Tractors">
                    <ListGroup variant="flush">
                      {product.tractors &&
                        product.tractors.map((tractor) => (
                          <ListGroup.Item key={tractor._id}>
                            <Row>
                              <Col md={1}>
                                <FaTractor className="iconStyle" />
                              </Col>
                              <Col>
                                <span className="text-capitalize">
                                  {tractor.list_description}
                                </span>
                                <p className="text-capitalize DescriptionAttatchment">
                                  {tractor.tire_description}
                                </p>
                              </Col>
                              {tractor.price ? (
                                <Col md={3}>
                                  $
                                  {parseFloat(tractor.price).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </Col>
                              ) : (
                                <Col md={3}>
                                  <span className="discontinued"></span>
                                </Col>
                              )}
                              <Col md={2}>
                                {addedTractor === tractor._id ? (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    className="buttonAdd"
                                    onClick={() =>
                                      removeFromQuoteHandlerTractor()
                                    }
                                  >
                                    Remove
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="buttonAdd"
                                    onClick={() =>
                                      addToQuoteHandlerTractor(tractor._id)
                                    }
                                    disabled={tractor.discontinued}
                                  >
                                    Add
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        ))}
                    </ListGroup>
                  </Tab>

                  {/* ATTACHMENTS & IMPLEMENTS */}
                  <Tab eventKey="attachments" title="Attachments & Implements">
                    <ListGroup variant="flush">
                      {product.attachments &&
                        product.attachments.map((attachment) => (
                          <ListGroup.Item key={attachment._id}>
                            <Row>
                              <Col md={1}>
                                <FaTractor className="iconStyle" />
                              </Col>
                              <Col>
                                <a
                                  href={attachment.url}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {attachment.name}
                                </a>
                                <p className="text-capitalize DescriptionAttatchment">
                                  {attachment.type.replace(/_/g, " ")}
                                </p>
                              </Col>
                              {userInfo && (
                                <Col md={3}>
                                  $
                                  {parseFloat(attachment.price).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </Col>
                              )}
                              <Col md={2}>
                                {attachment.discontinued ? (
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip id={`tooltip-${attachment._id}`}>
                                        Not available
                                      </Tooltip>
                                    }
                                    disabled={!attachment.discontinued}
                                  >
                                    <span>
                                      <Button
                                        variant={
                                          addedAttachments.includes(
                                            attachment._id
                                          )
                                            ? "outline-danger"
                                            : "outline-primary"
                                        }
                                        size="sm"
                                        className="buttonAdd"
                                        onClick={() =>
                                          addToQuoteHandler(attachment._id)
                                        }
                                        disabled={attachment.discontinued}
                                      >
                                        {addedAttachments.includes(
                                          attachment._id
                                        )
                                          ? "Remove"
                                          : "Add"}
                                      </Button>
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  <Button
                                    variant={
                                      addedAttachments.includes(attachment._id)
                                        ? "outline-danger"
                                        : "outline-primary"
                                    }
                                    size="sm"
                                    className="buttonAdd"
                                    onClick={() =>
                                      addToQuoteHandler(attachment._id)
                                    }
                                    disabled={attachment.discontinued}
                                  >
                                    {addedAttachments.includes(attachment._id)
                                      ? "Remove"
                                      : "Add"}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        ))}
                    </ListGroup>
                  </Tab>
                  <Tab eventKey="options" title="Options">
                    {/* Options content goes here */}
                    <ListGroup variant="flush">
                      {product.options &&
                        product.options.map((option) => (
                          <ListGroup.Item key={option._id}>
                            <Row>
                              <Col md={1}>
                                <FaPlusCircle className="iconStyle" />
                              </Col>
                              <Col>
                                <a
                                  href={option.url}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {option.name}
                                </a>
                                <p className="text-capitalize DescriptionAttatchment">
                                  {option.type.replace(/_/g, " ")}
                                </p>
                              </Col>
                              {userInfo && (
                                <Col md={3}>
                                  $
                                  {parseFloat(option.price).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </Col>
                              )}
                              <Col md={2}>
                                {option.discontinued ? (
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip id={`tooltip-${option._id}`}>
                                        Not available
                                      </Tooltip>
                                    }
                                    disabled={!option.discontinued}
                                  >
                                    <span>
                                      <Button
                                        variant={
                                          addedOptions.includes(option._id)
                                            ? "outline-danger"
                                            : "outline-primary"
                                        }
                                        size="sm"
                                        className="buttonAdd"
                                        onClick={() =>
                                          addToQuoteHandlerOptions(option._id)
                                        }
                                        disabled={option.discontinued}
                                      >
                                        {addedOptions.includes(option._id)
                                          ? "Remove"
                                          : "Add"}
                                      </Button>
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  <Button
                                    variant={
                                      addedOptions.includes(option._id)
                                        ? "outline-danger"
                                        : "outline-primary"
                                    }
                                    size="sm"
                                    className="buttonAdd"
                                    onClick={() =>
                                      addToQuoteHandlerOptions(option._id)
                                    }
                                    disabled={option.discontinued}
                                  >
                                    {addedOptions.includes(option._id)
                                      ? "Remove"
                                      : "Add"}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        ))}
                    </ListGroup>
                  </Tab>
                </Tabs>
              </ListGroup.Item>
              {/* SUMMMARY */}
              {userInfo && (
                <ListGroup.Item
                  style={{
                    padding: "20px",
                    border: "none",
                  }}
                >
                  {addedTractor && (
                    <ListGroup.Item
                      style={{
                        borderRadius: "10px 10px 0px 0px",
                      }}
                    >
                      <span>Tractor:</span>
                      <strong className="price style1">
                        $
                        {parseFloat(
                          product.tractors.find((t) => t._id === addedTractor)
                            .price
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </strong>
                    </ListGroup.Item>
                  )}

                  {addedAttachments.length > 0 && (
                    <ListGroup.Item>
                      <span>Attachments:</span>
                      <strong className="price style1">
                        $
                        {attachmentTotal.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </strong>
                    </ListGroup.Item>
                  )}
                  {addedOptions.length > 0 && (
                    <ListGroup.Item>
                      <span>Options:</span>
                      <strong className="price style1">
                        $
                        {optionTotal.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </strong>
                    </ListGroup.Item>
                  )}
                  {addedTractor ||
                  addedAttachments.length > 0 ||
                  addedOptions.length > 0 ? (
                    <ListGroup.Item
                      style={{
                        borderRadius: "0px 0px 10px 10px",
                      }}
                    >
                      <span>Subtotal:</span>
                      <strong className="price style1">${sumTotal}</strong>
                    </ListGroup.Item>
                  ) : null}
                </ListGroup.Item>
              )}
              {/* Add to cart or quote button */}
              <br></br>

              {userInfo ? (
                <Button
                  onClick={addToCartHandler}
                  className="button std"
                  type="button"
                  disabled={!addedTractor || product.discontinued === true}
                >
                  Proceed with Quote
                </Button>
              ) : (
                <Button
                  onClick={addToCartHandlerPublic}
                  className="button std"
                  type="button"
                  disabled={!addedTractor || product.discontinued === true}
                >
                  Add to Quote
                </Button>
              )}
            </ListGroup>
          </Col>
        </Row>
      )}
    </div>
  );
}
export default ProductScreen;
